<!-- 学期课程组件 -->
<template>
  <div class="courseList_">
      <el-row class="list_class" style="margin-bottom: 20px">
        <el-col
           :class="strExistHostnameOnce(['localhost','hbsi'])?'list_info_':''"
          :span="12"
          v-for="(item, index) in teachingPlanCourseList"
          :key="index + 'teachingPlanCourseList'"
        >
          <h4 style="margin: 15px 0 10px 0; font-size: 16px">
            {{ item.courseName }}
            <template v-if="!$strExistHostnameOnce(['localhost','lfjtysxx'])">
                <el-tag
                  class="courseTag"
                  v-if="item.semestersText && $gradeNotShow(['hbafajj'])"
                  >{{ item.semestersText }}</el-tag>
            </template>
            <!-- v-if="
                !strExistHostnameOnce(['localhost', 'hbjz']) &&
                item.semestersText
              " -->
            <el-tag class="courseTag" v-if="item.courseNatureConcat">{{
              item.courseNatureConcat
            }}</el-tag>
          </h4>
          <el-row>
            <div style="height: 150px">
              <el-image
                style="
                  height: 150px;
                  width: 240px;
                  float: left;
                  margin-right: 20px;
                  border-radius: 10px;
                "
                class="logo"
                :src="
                  $isEmpty(item.courseThumbnail)
                    ? png
                    : $isHttp(item.courseThumbnail)
                "
              >
              </el-image>

              <p
                :class="'sj limit_line_one '+ (item.makeUpExamExist != -1?'p_5_':'p_')"
                style="padding-top: 10px; margin-top: 0"
              >
                学习时间：
                <template v-if="item.infoShow1Str == '显示'">
                  <el-tooltip
                    class="item"
                    effect="light"
                    :content="'学习时间：' + $timeFormatTo(item.infoTime1Str)"
                    placement="top"
                  >
                    <span>{{ $timeFormatTo(item.infoTime1Str) }}</span>
                  </el-tooltip>
                </template>
              </p>
              <p :class="'sj limit_line_one '+ (item.makeUpExamExist != -1?'p_5_':'p_')">
                作业时间：
                <template v-if="item.infoShow3Str == '显示'">
                  <el-tooltip
                    class="item"
                    effect="light"
                    :content="'作业时间：' + $timeFormatTo(item.infoTime3Str)"
                    placement="top"
                  >
                    <span>{{ $timeFormatTo(item.infoTime3Str) }}</span>
                  </el-tooltip>
                </template>
              </p>
              <p :class="'sj limit_line_one '+ (item.makeUpExamExist != -1?'p_5_':'p_')">
                考试时间：
                <template v-if="item.infoShow4Str == '显示'">
                  <el-tooltip
                    class="item"
                    effect="light"
                    :content="'考试时间：' + $timeFormatTo(item.infoTime4Str)"
                    placement="top"
                  >
                    <span>{{ $timeFormatTo(item.infoTime4Str) }}</span>
                  </el-tooltip>
                </template>
              </p>
              <p :class="'sj limit_line_one '+ (item.makeUpExamExist != -1?'p_5_':'p_')" v-if="item.makeUpExamExist != -1">
                补考时间：
                <template>
                  <el-tooltip
                    class="item"
                    effect="light"
                    :content="'补考时间：' + (item.makeUpExamTimeInfo == '未设置' ? item.makeUpExamTimeInfo : $timeFormatTo(item.makeUpExamTimeInfo))"
                    placement="top"
                  >
                    <span>{{ item.makeUpExamTimeInfo == '未设置' ? item.makeUpExamTimeInfo : $timeFormatTo(item.makeUpExamTimeInfo) }}</span>
                  </el-tooltip>
                </template>
              </p>
              <p :class="'sj limit_line_one '+ (item.makeUpExamExist != -1?'p_5_':'p_')">
                <span style="float: left">学习进度：</span>
                <el-progress
                  :percentage="percentCompleteMap[item.tePlanCourseId]"
                  color="#70b603"
                  :stroke-width="12"
                  style="width: 200px; float: left"
                ></el-progress>
              </p>
            </div>
            <div style="color: red; font-size: 14px; margin-top: 10px">
              总成绩 = 学习成绩*{{ item.weight1Str || 0 }} + 作业成绩*{{
                item.weight3Str || 0
              }}
              <template v-if="!$strExistHostnameOnce(['localhost','hevttc'])">
              + 表现成绩*{{ item.weight2Str || 0 }}
              </template>
              + 考试成绩*{{
                item.weight4Str || 0
              }}
            </div>
            <div style="text-align: right; margin: 10px 1em 0.5em 0;min-height: 30px;">
              <el-button
                class="butInfo"
                v-if="item.infoShow1Str == '显示'"
                size="mini"
                @click="study(item)"
                >学习</el-button
              >
              <el-button
                class="butInfo"
                v-if="item.infoShow3Str == '显示'"
                size="mini"
                @click="schoolAssignment(item)"
                >作业</el-button
              >
              <el-button
                class="butInfo"
                v-if="item.infoShow4Str == '显示'"
                size="mini"
                @click="examList(item)"
                >考试</el-button
              >
              <el-button
                class="butInfo"
                v-if="item.makeUpExamExist != -1"
                size="mini"
                @click="makeUpExamList(item)"
                >补考</el-button
              >
              <el-button
                class="butInfo"
                v-if="item.infoShow5Str == '显示'"
                size="mini"
                @click="putQuestions(item)"
                >提问</el-button
              >
              <el-button
                class="butInfo"
                v-if="item.infoShow4Str == '显示' && (!$strExistHostnameOnce(['localhost','hbafajj']) || (item.grade != '2020' && item.grade != '2021'&& item.grade != '2022'))"
                size="mini"
                @click="scoreQuery(item)"
                >成绩</el-button
              >
            </div>
          </el-row>
        </el-col>
      </el-row>
  </div>
</template>
<script>
import {
  openWithRoleTag,
  getStudentInfoKeyForRoleTag,
  strExistHostnameOnce,
} from "../common/ulit";
import png from "@/images/course.png";
export default {
  name: "CourseList",
  components: {},
  props: {
    list: {
      //list 数据
      type: Array,
      default: [],
    },
    semesterType: {
      //学期类型 1:当前 2:全部
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      strExistHostnameOnce,
      png: png,
      teachingPlanCourseMap: {}, //课程信息map 所有学期
      mapIndex: [],
      teachingPlanCourseList: [], //课程信息
      videoList: [], //已学进度
      getNowTime: "",
      percentCompleteMap: {}, //完成比例
      activeNames: [""],
    };
  },
  computed: {
    getPayConfig() {
      return this.$store.getters.getPayConfig;
    },
  },
  created() {
    this.getLeaningCenterList();
    this.getNowDate();
  },
  methods: {
      validate_canIn(eventType) {
        //没有缴费是否允许进行下一步操作
        const fieldMap = {
          videoStudy: "canStudy",
          taskList: "canWork",
          examList: "canExam",
          makeUpExamList: "canRepealExam",
        };
        const config = this.getPayConfig;
        const canIn = config[fieldMap[eventType]];
        if (canIn === false) {
          this.$message({
            type: "warning",
            message: "您未缴费，无法操作！",
          });
          return false;
        } else {
          return true;
        }
      },
    getLeaningCenterList() {
      //获取课程List
      this.teachingPlanCourseList = this.list;
      if (this.list.length <= 0) {
        let param = {
          limit: 9999,
          page: 1,
          semesterType: this.semesterType,
        };
        this.$store.dispatch("user/getLeaningCenterList", param).then((ret) => {
          if (ret.code === 0 || ret.code === "0") {
            if (this.semesterType == 1) {
              this.teachingPlanCourseList = ret.data;
              sessionStorage.setItem(
                getStudentInfoKeyForRoleTag() + "_onlineLearningRows",
                JSON.stringify(ret.data)
              );
            } else {
              this.teachingPlanCourseMap = {};
              let list = [];
              for (let item in ret.data) {
                if(this.$isEmpty(this.teachingPlanCourseMap[item.replace('第第','第').replace('学期学期','学期')])){
                    this.teachingPlanCourseMap[item.replace('第第','第').replace('学期学期','学期')] = ret.data[item];
                    list.push({
                      index: item.replace(/第/g, "").replace(/学期/g, ""),
                      showName:item.replace('第第','第').replace('学期学期','学期'),
                      key: item.replace('第第','第').replace('学期学期','学期'),
                    });
                }else{
                   this.teachingPlanCourseMap[item.replace('第第','第').replace('学期学期','学期')] = this.teachingPlanCourseMap[item.replace('第第','第').replace('学期学期','学期')].concat(ret.data[item]);
                }
                this.teachingPlanCourseList =
                  this.teachingPlanCourseList.concat(ret.data[item]);
              }
              this.mapIndex = list.sort(function (a, b) {
                //根据学期排序
                return a.index - b.index;
              });
              sessionStorage.setItem(
                getStudentInfoKeyForRoleTag() + "_onlineLearningAllRows",
                JSON.stringify(ret.data)
              );
            }
            //根据课程tePlanCourseIds查询课程学习进度
            let tePlanCourseIds = "";
            this.teachingPlanCourseList.forEach((key) => {
              tePlanCourseIds += key.tePlanCourseId + ",";
            });
            if (tePlanCourseIds != "") {
              this.getStudentVideoInfo(tePlanCourseIds);
            }
          } else {
            this.$message({
              message: ret.msg,
              type: "warning",
            });
          }
        });
      } else {
        //根据课程tePlanCourseIds查询课程学习进度
        let tePlanCourseIds = "";
        this.teachingPlanCourseList.forEach((key) => {
          tePlanCourseIds += key.tePlanCourseId + ",";
        });
        if (tePlanCourseIds != "") {
          this.getStudentVideoInfo(tePlanCourseIds);
        }
      }
    },
    getStudentVideoInfo(tePlanCourseIds) {
      //查询课程的已学进度
      this.$store
        .dispatch("user/getStudentVideoInfo", {
          tePlanCourseIds: tePlanCourseIds,
        })
        .then((ret) => {
          if (ret.code === 0 || ret.code === "0") {
            ret.data.forEach((item) => {
              this.percentCompleteMap[item.tePlanCourseId] = Number(
                item.percentComplete.replace("%", "")
              );
            });
            this.percentCompleteMap = Object.assign(
              {},
              this.percentCompleteMap
            );
          } else {
            this.$message({ message: ret.msg, type: "warning" });
          }
        })
        .catch(() => {});
    },
    study(item) {
        // if (false === this.validate_canIn("videoStudy")) return;
      //学习
      let infoTime1Str = item.infoTime1Str; //学习时间
      let startDate = infoTime1Str.split(" 至 ")[0]; //开始时间
      let endDate = infoTime1Str.split(" 至 ")[1]; //结束时间
      const date = this.getNowTime; //当前时间
      // const date = "2022-12-10 00:20:20"; //当前时间
      if (this.$compareTime(date, startDate)) {
        this.$message({
          message: "学习时间还未开始",
          type: "error",
        });
        return;
      }
      if (this.$compareTime(endDate, date)) {
        this.$message({
          message: "学习时间已结束",
          type: "error",
        });
        return;
      }
      openWithRoleTag(
        window.location.origin +
          "/StartLearning?tePlanCourseId=" +
          item.tePlanCourseId +
          "&courseName=" +
          this.$Base64.encode(item.courseName)
      );
      // if(!this.$isEmpty(item.courseUrl)){
      //   window.open(item.courseUrl);
      // }else{
      //   window.open(window.location.origin + '/StartLearning?tePlanCourseId='+item.tePlanCourseId);
      // }
    },
    schoolAssignment(item) {
        // if (false === this.validate_canIn("taskList")) return;
      //作业
      let infoTime3Str = item.infoTime3Str; //作业时间
      let startDate = infoTime3Str.split(" 至 ")[0]; //开始时间
      let endDate = infoTime3Str.split(" 至 ")[1]; //结束时间
      const date = this.getNowTime; //当前时间
      // const date = "2022-12-10 00:20:20"; //当前时间
      if (this.$compareTime(date, startDate)) {
        this.$message({
          message: "作业时间还未开始",
          type: "error",
        });
        return;
      }
      if (this.$compareTime(endDate, date)) {
        this.$message({
          message: "作业时间已结束",
          type: "error",
        });
        return;
      }
      openWithRoleTag(
        window.location.origin +
          "/SchoolAssignment?tePlanCourseId=" +
          item.tePlanCourseId +
          "&courseName=" +
          this.$Base64.encode(item.courseName)
      );
    },
    scoreQuery() {
      this.$router.push({ name: "ScoreQuery" });
    },
    examList(item) {
        // if (false === this.validate_canIn("examList")) return;
      //考试
      let infoTime4Str = item.infoTime4Str; //考试时间
      let startDate = infoTime4Str.split(" 至 ")[0]; //开始时间
      let endDate = infoTime4Str.split(" 至 ")[1]; //结束时间
      const date = this.getNowTime; //当前时间
      // const date = "2022-12-10 00:20:20"; //当前时间
      if (this.$compareTime(date, startDate)) {
        this.$message({
          message: "考试时间还未开始",
          type: "error",
        });
        return;
      }
      if (this.$compareTime(endDate, date)) {
        this.$message({
          message: "考试时间已结束",
          type: "error",
        });
        return;
      }
      openWithRoleTag(
        window.location.origin +
          "/ExamList?tePlanCourseId=" +
          item.tePlanCourseId +
          "&courseName=" +
          this.$Base64.encode(item.courseName)
      );
    },
    putQuestions(item) {
      //提问
      openWithRoleTag(
        window.location.origin +
          "/PutQuestions?tePlanCourseId=" +
          item.tePlanCourseId +
          "&courseName=" +
          this.$Base64.encode(item.courseName)
      );
    },
    getNowDate() {
      const this_ = this;
      this.$store
        .dispatch("getNowTime")
        .then((res) => {
          if (res.code == 0) {
            this.getNowTime = res.data;
            // 对比当前时间和服务器时间（对比时间戳），如果时间相差超过【55秒钟】提示用户修改本地时间，否者可能会影响学习及考试结果
            let timeStamp_ = new Date(this.getNowTime).getTime() - new Date().getTime(); //两个时间戳的差值
            if(Math.abs(timeStamp_)  >= 1000 * 55){ //Math.abs 取绝对值
                // localStorage.setItem(this.$getStorageKeyForRoleTag("timeStamp_"),timeStamp_);
                //时间差大于55秒弹出提示信息
                this.$notify({
                    title: '系统提示',
                    type: 'warning',
                    position: 'bottom-right',
                     dangerouslyUseHTMLString: true,
                    message: '<h3 style="text-indent: 2em;color:red;">您的电脑时间与实际时间存在一定偏差，<br/>会影响学习、作业、考试等结果,<span>请及时调整！</span></h3>',
                    duration: 0
                });
            }
          } else {
            this.getNowTime = this.$getNewDate();
          }
        })
        .catch(function (error) {
          this_.getNowTime = this_.$getNewDate();
        });
    },
    makeUpExamList(item) {
      // if (false === this.validate_canIn("canRepealExam")) return;
      let infoTime4Str = item["makeUpExamTimeInfo"]; //考试时间
      let startDate = infoTime4Str.split(" 至 ")[0]; //开始时间
      let endDate = infoTime4Str.split(" 至 ")[1]; //结束时间
      const date = this.getNowTime; //当前时间
      if (this.$compareTime(date, startDate)) {
        this.$message({
          message: "补考时间还未开始",
          type: "error",
        });
        return;
      }
      if (this.$compareTime(endDate, date)) {
        console.log("endDate=" + endDate);
        console.log("date=" + date);
        this.$message({
          message: "补考时间已结束",
          type: "error",
        });
        return;
      }
        openWithRoleTag(window.location.origin + '/MakeUpExamList?tePlanCourseId=' + item.tePlanCourseId + "&courseName=" + this.$Base64.encode(item.courseName));
    },
  },
};
</script>
<style lang="less">
@import "../styles/base.less";
.courseList_ {
  .t_r {
    text-align: right;
  }

  .sj {
    color: #828282;
    font-size: 14px;
  }

  .p_ {
    margin-left: 10px;
    line-height: 20px;
  }

  .p_5_ {
    margin-left: 10px;
    line-height: 20px;
    margin-top: 5px !important;
    margin-bottom: 10px !important;
  }

  .titleClass {
    margin-left: 10px;
    font-weight: 500;
  }
  .courseTag {
    height: auto;
    background-color: @butBg;
    color: white;
    font-weight: 100;
    // float: right;
    border-radius: 20px;
    padding: 10px;
    font-size: 12px;
    line-height: 0;
    margin-right: 1em;
  }

  .el-progress__text {
    font-size: 12px !important;
  }
  .butInfo {
    color: white;
    padding: 8px 20px;
  }
  .butInfo:nth-child(2n) {
    background-color: #1eb0bb;
  }
  .butInfo:nth-child(2n + 1) {
    background-color: #73a1f7;
  }
  .list_class {
    float: left;
    width: 100%;
    margin-bottom: 20px;
    .el-col {
      // background: linear-gradient(to bottom, #fff, lighten(@butBg, 10%) 100%);
      padding: 0.4em 15px;
      box-sizing: border-box;
      border-radius: 10px;
      // box-shadow: 0 0 5px #fff inset;
    }
    .list_info_{
        background: linear-gradient(to bottom, #fff, lighten(@butBg, 10%) 100%);
        box-shadow: 0 0 5px #fff inset;
    }
  }
  .el-button:focus,
  .el-button:hover {
    color: white !important;
  }
  .list_class:nth-child(2n) {
    float: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/courseListLfjtysxx.vue